<template>
  <div>
    <div>
      <b-form-group :label="$t('message.Название') + ':'" label-for="Name">
        <b-form-input id="Name" type="text" v-model="model.name" required>
        </b-form-input>
      </b-form-group>
      <b-form-group :label="$t('message.Адаптер') + ':'" label-for="Handler">
        <b-form-input id="Handler" type="text" v-model="model.handler" required>
        </b-form-input>
      </b-form-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "EPG_SourceForm",
  props: ["model"],
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/EPG_SourcesForm.vue